var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoVpcListDeployment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "rhjsr6rtwa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.529412 0 0 0 0 0.576471 0 0 0 0 0.639216 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#rhjsr6rtwa)",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 22.667A6.667 6.667 0 1 1 22.667 16",
    stroke: "#A6AAB3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeLinejoin: "round",
    d: "m19.333 14.534 3.975 2.84 2.023-4.447"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVpcListDeployment);
export default __webpack_public_path__ + "static/media/ico-vpc-list-deployment.ee3817bc26eeee907f3cfb5871b2a8e9.svg";
export { ForwardRef as ReactComponent };